// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"333":"epub","962":"home"}[chunkId] || chunkId) + "." + {"333":"536ff113","546":"be030c48","869":"ced27a81","962":"9fce78b7"}[chunkId] + ".chunk.js";
};